import { DataType } from "../../../models/queries/queries.models";
import * as moment from "moment";
import { ChildComponent } from "../modules/child-component";
import * as DOMPurify from "dompurify";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { NotificationClientService } from "../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";

export class BaseHistoryTrail<T> extends ChildComponent<T>  {

    constructor(protected configService: ConfigService, notificationService: NotificationClientService, i18N: I18N) {
        super(notificationService, i18N);
    }

    getActionDetails(item) {
        const actionDetails = item.actionDetails;

        const div = document.createElement('div');
        div.innerHTML = DOMPurify.sanitize(actionDetails);

        let spans: Element[] = Array.from(div.querySelectorAll("span[data-type='12']"));
        spans = spans.concat(Array.from(div.querySelectorAll("span[data-type='7']")));
        
        spans.forEach(span => {
            const value = span.textContent;
            const date = moment.utc(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY H:mm:ss", "DD/MM/YYYY hh:mm:ss A", "DD/MM/YYYY h:mm:ss A"]).local();
            const parameters = span.getAttribute('parameters');

            const dataType = Number(span.getAttribute('data-type'));
            let datestring = null;

            if (parameters && parameters != null && parameters != "") {
                datestring = date.format(parameters);
            }
            else {
                datestring = date.format(dataType == DataType.Date ? this.configService.config.common.defaultDateFormat : this.configService.config.common.defaultDateTimeFormat);
            }
            span.textContent = datestring;
        });

        return div.innerHTML;
    }

    protected handleSpan(spanString: string, item) {
        const dataTypeString = "data-type='";
        const paramString = "parameters='";
        const dataTypeIndex = spanString.indexOf(dataTypeString);
        const parametersIndex = spanString.indexOf(paramString);
        const endSpanIndex = spanString.indexOf(">");
        const endSpanTagIndex = spanString.indexOf("</span>");

        const dataType = Number(spanString.substring(dataTypeIndex + dataTypeString.length, parametersIndex - 2));
        const parameters = spanString.substring(parametersIndex + paramString.length, endSpanIndex - 1);
        const value = spanString.substring(endSpanIndex + 1, endSpanTagIndex);

        if (dataType == DataType.DateTime || dataType == DataType.Date) {
            if (value && value != null && value != "") {
                let date = moment.utc(value).local();
                if (isNaN(Date.parse(value)) || !date.isValid()) {
                    //date formats that may return invalid date
                    date = moment.utc(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY H:mm:ss", "DD/MM/YYYY hh:mm:ss A", "DD/MM/YYYY h:mm:ss A"]).local();
                }

                let datestring = null;

                if (parameters && parameters != null && parameters != "") {
                    datestring = date.format(parameters);
                }
                else {
                    datestring = date.format(dataType == DataType.Date ? "MM/DD/YYYY" : "MM/DD/YYYY HH:mm");
                }

                item.actionDetails = item.actionDetails.replace(spanString, datestring);
            }
            else {
                const spanIndex = item.actionDetails.indexOf(spanString);

                const fromSubstring = item.actionDetails.substring(spanIndex - 5, spanIndex);

                let stringToReplace = spanString;

                if (fromSubstring.indexOf("from") > -1) {
                    stringToReplace = fromSubstring + spanString;
                }

                item.actionDetails = item.actionDetails.replace(stringToReplace, "");
            }
        }
    }
}